/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {completeExternalTransactionReversal} from '../api'

export const useMutationCompleteExternalTransactionReversal = createReactQueryMutationHook('completeExternalTransactionReversal', completeExternalTransactionReversal)
